<template>
  <div>
    <!-- 查询 -->
    <elastic-compute-cloud-resource-search
      :ecColumns="tableColumnsChecked"
      ref="child"
    ></elastic-compute-cloud-resource-search>
    <!-- 动态表头 -->
    <Checkbox-group
      v-model="tableColumnsChecked"
      @on-change="changeTableColumns"
    >
      <Collapse>
        <Panel name="1">
          <span style="font-size: 13px; font-weight: 600">{{
            $t("alarms.common.dynamicHeader")
          }}</span>
          <template slot="content">
            <Row>
              <Col span="24">
                <Row>
                  <Col span="6">
                    <Checkbox label="accountIdString" disabled>{{
                      $t("RAM.AWS.computeInstance.accountID")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="accountName">{{
                      $t("RAM.AWS.computeInstance.accountName")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="region">{{
                      $t("RAM.AWS.computeInstance.region")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="name">{{
                      $t("RAM.AWS.computeInstance.instanceName")
                    }}</Checkbox>
                  </Col>

                  <Col span="6">
                    <Checkbox label="instanceId">{{
                      $t("RAM.AWS.computeInstance.instanceID")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="instanceType">{{
                      $t("RAM.AWS.computeInstance.instanceType")
                    }}</Checkbox>
                  </Col>

                  <Col span="6">
                    <Checkbox label="cpu">{{
                      $t("RAM.AWS.computeInstance.CPU")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="ram">{{
                      $t("RAM.AWS.computeInstance.cache")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="storage">{{
                      $t("RAM.AWS.computeInstance.diskStorage")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="imageId">{{
                      $t("RAM.AWS.computeInstance.AMIID")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="amazonVpcId">{{
                      $t("RAM.AWS.computeInstance.VPCID")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="ebsDeviceName">{{
                      $t("RAM.AWS.computeInstance.EBSDevices")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="amazonCreditOptionStateName">{{
                      $t("RAM.AWS.computeInstance.T2T3Unlimited")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="os">{{
                      $t("RAM.AWS.computeInstance.OperatingSystem")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="stateName">{{
                      $t("RAM.AWS.computeInstance.stateName")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="project">{{
                      $t("RAM.AWS.computeInstance.Project")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="owner">{{
                      $t("RAM.AWS.computeInstance.Owner")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="systemStatus">{{
                      $t("RAM.AWS.computeInstance.SystemHealthStatus")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="instanceStatus">{{
                      $t("RAM.AWS.computeInstance.InstanceHealthStatus")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="publicIp">{{
                      $t("RAM.AWS.computeInstance.PublicIP")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="privateIp">{{
                      $t("RAM.AWS.computeInstance.PrivateIP")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="virtualNetworkSubnet">{{
                      $t("RAM.AWS.computeInstance.SubnetID")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="instanceCreatedTime">{{
                      $t("RAM.AWS.computeInstance.CreationTime")
                    }}</Checkbox>
                  </Col>
                </Row>
              </Col>
            </Row>
          </template>
        </Panel>
      </Collapse>
    </Checkbox-group>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%"
    ></Table>
    <br />
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import {getCookie} from "../../../../../utils/cookieUtil";

let tableDataVue = {};
export default {
  name: "TableElasticComputeCloudResource",
  components: {
    ElasticComputeCloudResourceSearch: () =>
      import("../ec2/ElasticComputeCloudResourceSearch")
  },
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      val: "",
      region: "",
      tableColumnsChecked: [
        "accountIdString",
        "accountName",
        "region",
        "name",
        "instanceId",
        "instanceType",
        "cpu",
        "ram",
        "storage"
      ],
      columns: [],
      tableData: []
    };
  },
  beforeCreate: function() {
    tableDataVue = this;
  },
  mounted: function() {
    tableDataVue.changeTableColumns();
  },
  methods: {
    showAll: function() {
      tableDataVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function() {
      this.$api.resourceManagement
        .selectAWSInstanceByPage({
          companyId: tableDataVue.companyId,
          accountIdList: tableDataVue.accountSearchKey,
          accountName: tableDataVue.accountName,
          queryList: tableDataVue.queryList,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tableData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableDataVue.getData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableDataVue.getData();
    },
    // 销毁
    beforeDestroy: function() {
      eventBus.$off("companyId");
      eventBus.$off("queryList");
      eventBus.$off("accountSearchKey");
    },
    /************************* 动态表头 *******************************/
    getColumns() {
      const tableColumnList = {
        accountIdString: {
          title: this.$t("RAM.AWS.computeInstance.accountID"),
          fixed: "left",
          width: 120,
          key: "accountIdString"
        },
        accountName: {
          title: this.$t("RAM.AWS.computeInstance.accountName"),
          width: 150,
          key: "accountName"
        },
        region: {
          title: this.$t("RAM.AWS.computeInstance.region"),
          width: 150,
          key: "region"
        },
        name: {
          title: this.$t("RAM.AWS.computeInstance.instanceName"),
          width: 150,
          key: "name"
        },
        instanceId: {
          title: this.$t("RAM.AWS.computeInstance.instanceID"),
          width: 150,
          key: "instanceId"
        },
        instanceType: {
          title: this.$t("RAM.AWS.computeInstance.instanceType"),
          width: 150,
          key: "instanceType"
        },
        cpu: {
          title: this.$t("RAM.AWS.computeInstance.CPU"),
          width: 150,
          key: "cpu"
        },
        ram: {
          title: this.$t("RAM.AWS.computeInstance.cache"),
          width: 150,
          key: "ram"
        },
        imageId: {
          title: this.$t("RAM.AWS.computeInstance.AMIID"),
          width: 150,
          key: "imageId"
        },
        amazonVpcId: {
          title: this.$t("RAM.AWS.computeInstance.VPCID"),
          width: 150,
          key: "amazonVpcId"
        },
        ebsDeviceName: {
          title: this.$t("RAM.AWS.computeInstance.EBSDevices"),
          width: 150,
          key: "ebsDeviceName"
        },
        amazonCreditOptionStateName: {
          title: this.$t("RAM.AWS.computeInstance.T2T3Unlimited"),
          width: 150,
          key: "amazonCreditOptionStateName"
        },
        os: {
          title: this.$t("RAM.AWS.computeInstance.OperatingSystem"),
          width: 150,
          key: "os"
        },
        stateName: {
          title: this.$t("RAM.AWS.computeInstance.stateName"),
          width: 150,
          key: "stateName"
        },
        project: {
          title: this.$t("RAM.AWS.computeInstance.Project"),
          width: 150,
          key: "project"
        },
        owner: {
          title: this.$t("RAM.AWS.computeInstance.Owner"),
          width: 150,
          key: "owner"
        },
        systemStatus: {
          title: this.$t("RAM.AWS.computeInstance.SystemHealthStatus"),
          width: 150,
          key: "systemStatus"
        },
        instanceStatus: {
          title: this.$t("RAM.AWS.computeInstance.InstanceHealthStatus"),
          width: 150,
          key: "instanceStatus"
        },
        publicIp: {
          title: this.$t("RAM.AWS.computeInstance.PublicIP"),
          width: 150,
          key: "publicIp"
        },
        privateIp: {
          title: this.$t("RAM.AWS.computeInstance.PrivateIP"),
          width: 150,
          key: "privateIp"
        },
        virtualNetworkSubnet: {
          title: this.$t("RAM.AWS.computeInstance.SubnetID"),
          width: 150,
          key: "virtualNetworkSubnet"
        },
        instanceCreatedTime: {
          title: this.$t("RAM.AWS.computeInstance.CreationTime"),
          width: 150,
          key: "instanceCreatedTime"
        },
        storage: {
          title: this.$t("RAM.AWS.computeInstance.diskStorage"),
          width: 150,
          key: "storage"
        }
      };

      let data = [];
      this.tableColumnsChecked.forEach(col => data.push(tableColumnList[col]));
      return data;
    },
    changeTableColumns() {
      this.columns = this.getColumns();
    },
    update: function() {
      this.updateLoading = true;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.$refs.child.companyId,
          accountIdList: this.$refs.child.accountSearchKey,
          resourceManagement: 0,
          accountType: 0
        })
        .then(res => {
          this.updateLoading = false;
          setTimeout(() => {
            this.$Message.success(this.$t('common.updateSuccess'));
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      this.$refs.exportChild.openExport(0);
    },
    export: function(chooseType) {
      var exportDTO = {
        companyId: this.$refs.child.companyId,
        accountIdList: this.$refs.child.accountSearchKey,
        queryList: this.$refs.child.queryList
      };
      // 点击 是
      if (chooseType == true) {
        this.$refs.exportChild.loading = true;
        exportDTO.exportWithTag = true;
      }
      // 点击 否
      else {
        this.$refs.exportChild.modal_loading = true;
        exportDTO.exportWithTag = false;
      }
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });
      // 下载Excel 文件
      this.$api.resourceManagement.exportAWSInstance(exportDTO).then(res => {
        this.exportResponse(res);
        if (chooseType == true) {
          this.$refs.exportChild.loading = false;
        } else {
          this.$refs.exportChild.modal_loading = false;
        }
        // 关闭导出弹出框
        this.$refs.exportChild.exportModal = false;
      });
    },
    //多行导出
    exportAWSInstancesAndSecurityGroup: function() {
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAWSInstancesAndSecurityGroup({
          companyId: this.$refs.child.companyId,
          accountIdList: this.$refs.child.accountSearchKey,
          accountName: this.$refs.child.accountName,
          instanceId: this.$refs.child.instanceId,
          instanceName: this.$refs.child.instanceName,
          publicIp: this.$refs.child.publicIp
        })
        .then(res => {
          this.exportResponse(res);
          this.modal_loading = false;
        });
    },
    //导出指标统计
    exportAWSInstanceMetrics: function() {
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAWSInstanceMetrics({
          companyId: this.$refs.child.companyId,
          accountIdList: this.$refs.child.accountSearchKey,
          accountName: this.$refs.child.accountName,
          instanceId: this.$refs.child.instanceId,
          instanceName: this.$refs.child.instanceName,
          publicIp: this.$refs.child.publicIp
        })
        .then(res => {
          this.exportResponse(res);
          this.modal_loading = false;
        });
    },
    exportResponse: function(res) {
      let fileName = this.$t('RAM.export.computeInstance');
      let blob = new Blob([res.data], { type: "application/x-xls" });
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
      }
      this.$Message.destroy();
      this.$Message.success(this.$t('common.exportSuccess'));
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/ec2/TableElasticComputeCloudResource.vue